import React, { useState, useEffect } from "react";
import { Box, Grid, Tabs, Tab, TextField, InputAdornment, Card, CardContent, Button, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { db } from "../LoginPage"; // Import Firebase config
import { collection, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { useImageContext } from "../context/ImageContext"; // Import context

const TemplatePage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [templates, setTemplates] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const { setSelectedImage } = useImageContext(); // Use context

  // Fetch templates from Firestore
  useEffect(() => {
    const fetchTemplates = async () => {
      const templatesRef = collection(db, "templates"); // Firestore collection name
      const snapshot = await getDocs(templatesRef);
      const templatesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setTemplates(templatesData);
    };

    fetchTemplates();
  }, []);

  // Filter templates based on search input
  const filteredTemplates = templates.filter(template =>
    template.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleEdit = (imagePath) => {
    setSelectedImage(`/templates/${imagePath}`); // Store image in context
    navigate("/app/editor"); // Navigate without passing URL params
  };


  return (
    <Box sx={{ p: 3 }}>
      {/* Search Bar */}
      <Box display="flex" justifyContent="flex-end" sx={{ mb: 3 }}>
        <TextField
          placeholder="Search Your Favourite Design"
          variant="outlined"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ width: "300px", borderRadius: "30px" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
      </Box>

      {/* Tabs */}
      <Tabs value={tabIndex} onChange={(e, newValue) => setTabIndex(newValue)}>
        <Tab label="Popular" />
        <Tab label="Recent" />
        <Tab label="Premium" />
      </Tabs>

      {/* Template List */}
      <Box sx={{ mt: 3 }}>
        <Grid container spacing={3}>
          {filteredTemplates.length > 0 ? (
            filteredTemplates.map((template) => (
              <Grid item xs={12} sm={6} md={4} key={template.id}>
                <Card sx={{ textAlign: "center", p: 2, borderRadius: "10px", boxShadow: 3 }}>
                  <CardContent>
                    <Box display="flex" justifyContent="center" mb={2}>
                      <img
                        src={`/templates/${template.image}`}
                        alt={template.title}
                        style={{ width: "100%", maxWidth: "180px" }}
                      />
                    </Box>
                    <Typography variant="h6" sx={{ mb: 2 }}>{template.title}</Typography>
                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "#3F51B5", color: "white" }}
                      onClick={() => handleEdit(`${template.image}`)}
                    >
                      Edit
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ textAlign: "center", mt: 5 }}>
                No templates found
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>

    </Box>
  );
};

export default TemplatePage;
